import {
  LIST_REPORTA,
  LIST_REPORTA_SUCCESS,
  LIST_REPORTA_CLEAN,
  LIST_REPORTA_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  report: [],
}

const ReportAList = (state = initialState, action) => {
  switch (action.type) {
    case LIST_REPORTA:
      state = {
        ...state,
        loading: true,
      }
      break
    case LIST_REPORTA_SUCCESS:
      state = {
        ...state,
        report: action.payload.report,
        loading: false,
        done: true,
      }
      break
    case LIST_REPORTA_CLEAN:
      state = initialState
      break
    case LIST_REPORTA_ERROR:
      state = { ...state, error: action.payload, loading: false, done: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default ReportAList
